import { render, staticRenderFns } from "./InspectionTaskDetail.vue?vue&type=template&id=74762168&scoped=true"
import script from "./InspectionTaskDetail.vue?vue&type=script&lang=js"
export * from "./InspectionTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./InspectionTaskDetail.scss?vue&type=style&index=0&id=74762168&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74762168",
  null
  
)

export default component.exports